import { Component, OnInit } from '@angular/core';
import { catchError, from, map, Observable, of } from 'rxjs';
import { signOut, fetchAuthSession } from '@aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  public isAuthenticated$: Observable<boolean> = of(false);

  ngOnInit(): void {
    this.isAuthenticated$ = from(fetchAuthSession()).pipe(
      map((session) => !!session.tokens?.accessToken),
      catchError(() => of(false))
    );
  }

  async logout() {
    await signOut();
    window.location.href = environment.authConfig.signOutRedirect;
  }
}
